"use client";

import Link from "next/link";
import { useParams } from "next/navigation";
import { useLocale, useTranslations } from "next-intl";
import { Button } from "@/ui/components/ui/button";

/** Backend failures must stay distinguishable from a genuinely missing category. */
export default function CategoryError({ reset }: { error: Error & { digest?: string }; reset: () => void }) {
	const locale = useLocale();
	const { channel } = useParams<{ channel: string }>();
	const common = useTranslations("common");
	const cart = useTranslations("cart");
	return (
		<main className="mx-auto max-w-3xl px-4 py-12 sm:px-6" role="alert">
			<h1 className="text-2xl font-semibold">{common("error")}</h1>
			<div className="mt-6 flex flex-wrap items-center gap-4">
				<Button onClick={reset} className="min-h-11">
					{cart("retryAdd")}
				</Button>
				<Link
					href={`/${locale}/${channel === "us" ? "us" : "eu"}/products`}
					className="inline-flex min-h-11 items-center underline underline-offset-4"
				>
					{common("products")}
				</Link>
			</div>
		</main>
	);
}
